import * as types from "./mutation-types";

export default {
  [types.SET_TABLE_MODE](state) {
    state.tableMode = !state.tableMode;
  },
  [types.SET_DETAILS_IS_ACTIVE](state, payload) {
    state.detailsIsActive = payload;
  },
  [types.SET_DETAILS_ID](state, payload) {
    state.detailsId = payload;
  },
  [types.SET_FILTERS_TAB_IS_ACTIVE](state, payload) {
    state.filtersTabIsActive = payload;
  },
  [types.SET_PREFERENCES_MODAL_IS_ACTIVE](state, payload) {
    state.preferencesModalIsActive = payload;
  },
  [types.SET_PREFERENCES_ID](state, payload) {
    state.preferencesId = payload;
  },

  // FILTERS
  [types.SET_SEARCH_FILTER](state, payload) {
    state.searchFilter = payload;
  },
  [types.SET_ACTIVE_FILTERS](state, payload) {
    state.activeFilters = payload;
  },
  [types.CLEAR_FILTERS](state) {
    state.activeFilters = {};
    state.searchFilter = "";
  },
};
